<template>
  <div
    class="entry-hero bg-color-base d-flex align-items-end"
    :style="`background-image: url(${cover})`"
  >
    <div class="entry-hero__content text-left">
      <h1 class="entry-hero__content__title h2 px-5 container">{{ title }}</h1>
    </div>
  </div>
</template>

<script>
export default {
  name: "EntryHero",
  props: {
    title: String,
    cover: String
  },
  methods: {
    //
  }
};
</script>

<style scoped lang="sass">
.entry-hero
  background-repeat: no-repeat
  background-size: cover
  background-position: center center
  text-align: center
  height: calc( 100vh - 94px )
  &__content
    padding: 4rem 0 8rem
    position: relative
    width: 100%
    &:before
      content: ''
      position: absolute
      bottom: 0
      left: 0
      width: 85%
      height: 100%
      background-color: #D5DBD0
    &__title
      position: relative
      z-index: 1
  @media screen and (max-width: 502px)
    height: calc(60vh - 94px)
    &__content
      bottom: 0
      padding: 1rem
      z-index: 3
      &__title
        font-size: 1.5rem
</style>
